'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var mobileIconFontSize = exports.mobileIconFontSize = '22px';


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/conversations-internal-components/static-1.4266/js/visitor-widget/constants/mobileConstants.js
// module id = 551
// module chunks = 2 3